// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import { Capacitor } from '@capacitor/core';

// const ROLE_HOME = {
//   admin: '/admin',
//   farmer: '/farmer',
//   butcher: '/butcher',
//   customer: '/customer',
// };

// const isMobileWeb = () => window.innerWidth <= 768;
// const isMobile = () => Capacitor.isNativePlatform() || isMobileWeb();

// const RootRedirect = ({ children }) => {
//   const { user, loading } = useAuth();
//   const location = useLocation();

//   if (loading) return null;

//   // Explicit "Back to Site" navigation from a dashboard — always show the homepage.
//   if (location.state?.viewHome) {
//     return children;
//   }

//   if (isMobile()) {
//     if (!user?.token) {
//       return <Navigate to="/login" replace />;
//     }
//     if (user.role === 'customer') {
//       return <Navigate to={ROLE_HOME.customer} replace />;
//     }
//     return children;
//   }

//   // Desktop web only
//   if (user?.token) {
//     return <Navigate to={ROLE_HOME[user.role] || '/login'} replace />;
//   }

//   return children;
// };

// export default RootRedirect;

const RootRedirect = ({ children }) => {
  return children;
};

export default RootRedirect;